export default "__VITE_ASSET__CkvnMm4a__"